import {SecureService} from "@/services/superclasses/secure-service";
import {PostNewsletterDateCount} from "@/interfaces/post-newsletter-date-count";
import {PostNewsletterDate} from "@/interfaces/post-newsletter-date";

const api = window.contextPath + '/rest/post-newsletter-dates';

export class PostNewsletterDateSecureService extends SecureService {

    public counts = async (type: Array<number>, host: number, post?: number): Promise<PostNewsletterDateCount[]> => {
        return this.data(await this.get<PostNewsletterDateCount[]>(api + "/counts",
            {
                params: {
                    type,
                    host,
                    post
                }
            }))
    };

    public ran = async (post: number): Promise<PostNewsletterDate[]> => {
        return this.data(await this.get<PostNewsletterDate[]>(api + "/ran",
            {
                params: {
                    post
                }
            }))
    };
}

export const postNewsletterDateSecureService = new PostNewsletterDateSecureService()